import React, { useEffect, useState } from "react";
import AffiliateCampaignInvite from "./AffiliateCampaignInvite";
import PopupWrapper from "./PopupWrapper";

function PopupWrapperPage() {
  const [showURLSection, setShowURLSection] = useState(false);
  const [campaignData, setCampaignData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const product_id = params.get("productid") || "";
    const campaign_id = params.get("campaignid") || "";
    const affiliate_user_id = params.get("affiliateuserid") || "";

    // store ONLY if anything exists
    if (product_id || campaign_id || affiliate_user_id) {
      setCampaignData({
        product_id,
        campaign_id,
        affiliate_user_id,
      });
    }
  }, []);

  // If no params → show Activate section anyway
  if (!campaignData) {
    return (
      <PopupWrapper onClose={() => (window.location.href = "/")}>
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Activate Affiliate Campaign</h2>
          <p style={{ marginTop: "10px" }}>
            Click below to activate your campaign.
          </p>

          <button
            onClick={() => setShowURLSection(true)}
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "12px 25px",
              marginTop: "25px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Activate
          </button>
        </div>
      </PopupWrapper>
    );
  }

  return (
    <PopupWrapper onClose={() => (window.location.href = "/")}>
      {!showURLSection ? (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Activate Affiliate Campaign</h2>
          <p style={{ marginTop: "10px" }}>
            Click below to activate your campaign.
          </p>

          <button
            onClick={() => setShowURLSection(true)}
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "12px 25px",
              marginTop: "25px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Activate
          </button>
        </div>
      ) : (
        <AffiliateCampaignInvite
          campaign={campaignData}
          onClose={() => (window.location.href = "/")}
        />
      )}
    </PopupWrapper>
  );
}

export default PopupWrapperPage;
